<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <div class="text-caption font-weight-bold grey--text">ĐIỀU KIỆN LỌC</div>
      <v-btn
        small
        text
        color="primary"
        @click="addCondition"
        :disabled="!layerId"
      >
        <v-icon small left>mdi-plus</v-icon> Thêm
      </v-btn>
    </div>

    <div
      v-if="!layerId"
      class="text-caption grey--text font-italic text-center py-2"
    >
      Vui lòng chọn lớp dữ liệu trước
    </div>

    <div
      v-else-if="filters.length === 0"
      class="text-caption grey--text font-italic text-center py-2"
    >
      Chưa có điều kiện nào
    </div>

    <div
      v-for="(item, index) in filters"
      :key="index"
      class="mb-3 pa-2 rounded"
      style="border: 1px solid #e0e0e0; width: 100%;"
    >
      <!-- Dòng 1: Trường + Nút Xóa -->
      <div class="d-flex align-center mb-2" style="width: 100%;">
        <v-select
          v-model="item.field"
          :items="fields"
          item-text="name"
          item-value="code"
          placeholder="Trường"
          dense
          outlined
          hide-details
          class="flex-grow-1 mr-2"
          style="min-width: 0;"
          @change="emitUpdate"
        >
          <template v-slot:selection="{ item }">
            <span class="text-truncate" style="max-width: 100%;">{{
              item.name
            }}</span>
          </template>
        </v-select>

        <v-btn
          icon
          small
          color="error"
          class="flex-shrink-0"
          @click="removeCondition(index)"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Dòng 2: Toán tử + Giá trị -->
      <div class="d-flex align-center" style="width: 100%;">
        <v-select
          v-model="item.operator"
          :items="operators"
          item-text="text"
          item-value="value"
          placeholder="Toán tử"
          dense
          outlined
          hide-details
          class="mr-2 flex-shrink-0"
          style="width: 110px; min-width: 110px;"
          @change="emitUpdate"
        ></v-select>

        <v-text-field
          v-model="item.value"
          placeholder="Giá trị"
          dense
          outlined
          hide-details
          class="flex-grow-1"
          style="min-width: 0;"
          @input="emitUpdate"
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QueryBuilder',
  props: {
    layerId: {
      type: Number,
      default: null,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    filters: [],
    operators: [
      { text: '=', value: '=' },
      { text: '≠', value: '!=' },
      { text: '>', value: '>' },
      { text: '≥', value: '>=' },
      { text: '<', value: '<' },
      { text: '≤', value: '<=' },
      { text: 'LIKE', value: 'LIKE' },
      { text: 'IN', value: 'IN' },
    ],
  }),
  watch: {
    layerId: {
      handler() {
        this.filters = []
        this.emitUpdate()
      },
      immediate: true,
    },
  },
  methods: {
    addCondition() {
      this.filters.push({
        field: null,
        operator: 'LIKE',
        value: '',
      })
      this.emitUpdate()
    },
    removeCondition(index) {
      this.filters.splice(index, 1)
      this.emitUpdate()
    },
    emitUpdate() {
      // Chỉ emit những filter hợp lệ (đủ field và operator)
      const validFilters = this.filters.filter((f) => f.field && f.operator)
      this.$emit('update:filters', validFilters)
    },
  },
}
</script>
